import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "sidebarTrigger"]

  connect() {
    if (localStorage.getItem("columnLayoutComponent") === "collapsed") {
      this.sidebarTarget.classList.add("is-collapsed")
    }
  }

  toggleSidebar() {
    if (this.sidebarTarget.classList.contains("is-collapsed")) {
      this.sidebarTarget.classList.remove("is-collapsed")
      localStorage.removeItem("columnLayoutComponent")
    } else {
      this.sidebarTarget.classList.add("is-collapsed")
      localStorage.setItem("columnLayoutComponent", "collapsed")
    }
  }
}
